import { render, staticRenderFns } from "./VersionDetail.vue?vue&type=template&id=d740d87e&"
import script from "./VersionDetail.vue?vue&type=script&lang=js&"
export * from "./VersionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports